<template>
  <div v-if="emissionsData.length > 1" class="my-2 rounded border border-gray-200 bg-gray-50 p-3">
    <div class="mb-2 flex items-center justify-between">
      <h3 class="text-base font-semibold text-gray-900">{{ $t("shared.checkout.environmental_impact") }}</h3>
      <VcIcon name="chart-square" :size="28" class="text-green-600" />
    </div>

    <div class="space-y-2">
      <div v-for="method in sortedEmissions" :key="method.code">
        <div class="flex items-start gap-2">
          <div class="min-w-20 text-xs font-medium text-gray-700">{{ method.name }}</div>

          <div class="flex-1">
            <div
              class="relative h-2 w-full overflow-hidden rounded-full bg-gradient-to-r from-yellow-100 to-yellow-300"
            >
              <div
                class="absolute left-0 top-0 h-full bg-gradient-to-r from-green-400 to-green-500 transition-all duration-300"
                :style="{ width: `${(method.co2Emissions / maxScaleValue) * 100}%` }"
              ></div>
              <div
                v-if="method.code === selectedMethod"
                class="absolute top-1/2 size-2.5 -translate-y-1/2 rounded-full border-2 border-gray-800 bg-white shadow-sm transition-all duration-200"
                :style="{ left: `calc(${(method.co2Emissions / maxScaleValue) * 100}% - 5px)` }"
              ></div>
            </div>

            <div class="mt-0.5 flex justify-between text-[0.65rem] font-medium">
              <span>0</span>
              <span>{{ $t("shared.checkout.co2_emission_in_kg") }}</span>
              <span>{{ maxScaleValue }}+</span>
            </div>
          </div>

          <div class="w-12 text-right text-xs font-semibold">{{ method.co2Emissions }} kg</div>
        </div>
      </div>
    </div>

    <p class="mt-2 text-xs font-medium">
      {{ $t("shared.checkout.co2_emissions_disclaimer") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface ICo2EmissionData {
  code: string;
  name: string;
  co2Emissions: number;
}

// Static data for now - can be replaced with props/API data in the future
const emissionsData = computed<ICo2EmissionData[]>(() => [
  { code: "ups_standard", name: "UPS Standard", co2Emissions: 2.8 },
  { code: "fedex_express", name: "FedEx Express", co2Emissions: 4.2 },
  { code: "dhl_express", name: "DHL Express", co2Emissions: 3.5 },
  { code: "ups_ground", name: "UPS Ground", co2Emissions: 1.9 },
]);

const sortedEmissions = computed(() => {
  return [...emissionsData.value].sort((a, b) => a.co2Emissions - b.co2Emissions);
});

// TODO: Replace with actual selected shipping method from parent component
const selectedMethod = computed(() => "ups_ground");

// Scale value for the gradient bar (max display value on the chart)
const maxScaleValue = computed(() => 5);
</script>
